module.exports = __webpack_public_path__ + "img/public/SiteIcons/listCloseIcon.svg?d0ae1812";